<kendo-dialog class="duplicate-dialog" *ngIf="opened" [minWidth]="250" [width]="300">
    <div class="duplicate-header">
        <label class="duplicate-events-list">{{'addin.duplicate_events_list'
            |stringLiterals}}</label>
        <smart-icon class="dialog-close" name="close" (click)="clickClose($event)">
        </smart-icon>
    </div>

    <hr>
    <div class="body-content">
        <div *ngFor="let item of data" class="item-data" [ngClass]="{'selected-event-item':item.isSelected}"
            (click)="clickEventItem(item)">
            <span class="subject">{{item.subject}}</span>

            <span [ngClass]="{'entry-type':this.currentType.id!==item.entryType.id}">{{item.entryType.name}}</span>
            <div class="item-row third">
                <smart-icon name="calendar" class="date"></smart-icon>
                <span class="date-value">{{item.date}}</span>
            </div>
            <div class="item-row forth">
                <smart-icon name="users-o" class="particpants-icon"></smart-icon>
                <div class="particpants-value-container-min">
                    <span class="particpants-values"
                        *ngFor="let item of item.Attendees;let last=last;trackBy:trackByFn">{{item["short-name"]}}{{last
                        ? '' : '; '}}</span>
                </div>
            </div>
            <div class="item-location">
                <smart-icon name="location" class="location"></smart-icon>
                <span class="location-value">{{item.Location}}</span>
            </div>
        </div>
    </div>


    <div class="update-item">
        <label (click)="clickUpdateEvent($event)">{{'addin.update_selected_event_with_the_new_one'
            |stringLiterals}}</label>
    </div>

</kendo-dialog>